import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getDatabase, ref, get } from 'firebase/database';
import { database } from '../../auth/firebase';
import Footer from '../../common/Footer';
import Nav from '../../common/Nav';
import BookingPopup from './BookingPopUp';

const BookingPage = () => {
  const { id } = useParams();
  const [hotel, setHotel] = useState(null);

  useEffect(() => {
    // const db = getDatabase();
    get(ref(database, `hotels/${id}`)).then((snapshot) => {
      setHotel(snapshot.val());
    });
  }, [id]);

  if (!hotel) return <div className="p-10">Loading...</div>;

  const price = 3906;
  const instantDiscount = 1964;
  const couponDiscount = 1165;
  const finalAmount = price - instantDiscount - couponDiscount;

  return (
    <div>
        <div>
            <Nav/>
        </div>
    <div className="p-6 md:px-20 flex flex-col md:flex-row gap-8 my-20">
      <div className="flex-1 bg-white p-6 rounded shadow">
        <h2 className="text-lg font-bold mb-4">Enter your details</h2>
        <input className="border p-2 w-full mb-4" placeholder="Full Name" />
        <input className="border p-2 w-full mb-4" placeholder="Email Address" />
        <input className="border p-2 w-full mb-4" placeholder="Mobile Number" />
        <button className="bg-gray-200 px-4 py-2 rounded text-gray-700" disabled>
          Send passcode
        </button>
      </div>

      <div className="w-full md:w-96 bg-white p-6 rounded shadow">
        <h3 className="text-md font-semibold mb-2">{hotel.name}</h3>
        <img src={hotel.images?.hotel?.[0]} className="h-32 w-full object-cover rounded mb-2" />
        <p className="text-sm mb-1">📅 1 Night | 1 Room, 1 Guest</p>
        <p className="text-sm mb-1">🏨 {hotel.type}</p>
        <hr className="my-2" />
        <p>Room price: ₹{price}</p>
        <p className="text-green-600">-₹{instantDiscount} Instant Discount</p>
        <p className="text-green-600">-₹{couponDiscount} Coupon Discount</p>
        <hr className="my-2" />
        <p className="font-bold">Payable Amount: ₹{finalAmount}</p>
      </div>
      </div>
      <BookingPopup />
      <Footer/>
    </div>
  );
};

export default BookingPage;
